import { defineStore, acceptHMRUpdate } from 'pinia';

const store = defineStore('multiprojects-process', {
  state: () => ({
    projectStepId2DashboardStepId: {
      // `${projectId}.${processStep}`: dashboardStepId
    },
  }),

  actions: {
    resetProjectStepId2DashboardStepId() {
      this.projectStepId2DashboardStepId = {};
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
